import React from 'react'
import"./Common_Title.css"
function Common_Title({title_text}) {
  return (
    <div className='title-holder'>
             <p> {title_text}</p>
        </div>
  )
}

export default Common_Title